// extracted by mini-css-extract-plugin
export default {"wrapper":"Basic_wrapper__DIyDB","files":"Basic_files__JZk+a","fields":"Basic_fields__P62zn"};